var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_SHERBERT_BASE_URL } from './baseUrl';
import { ApiError, Fetcher } from './utilities/fetcher';
import { makePollingRequest } from './utilities';
import { DEFAULT_INIT_POLLING } from './sherbertClient';
const fetcher = Fetcher.for(DEFAULT_SHERBERT_BASE_URL);
const poll = (fn) => (...args) => __awaiter(void 0, void 0, void 0, function* () {
    const initialApiResponse = yield fn(...args);
    const { headers, signal } = args[1];
    if (!initialApiResponse.ok) {
        throw new ApiError(initialApiResponse);
    }
    if (initialApiResponse.status === 202) {
        const location = initialApiResponse.headers.get('Location');
        if (!location) {
            throw new Error('No Location header in response');
        }
        return makePollingRequest({
            url: location,
            headers,
            signal: signal !== null && signal !== void 0 ? signal : undefined,
        });
    }
    return initialApiResponse;
});
export const getMetadataV3 = fetcher.path('/v3/assets/{id}/metadata').method('get').create();
export const getAssetV3 = fetcher.path('/v3/assets/{id}').method('get').create();
export const getVariantMetadataWithPollingV3 = poll(fetcher.path('/v3/assets/{id}/{variant}/metadata').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getVariantWithPollingV3 = poll(fetcher.path('/v3/assets/{id}/{variant}').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getMultiPageVariantV3 = poll(fetcher.path('/v3/assets/{id}/{pageNum}/{variant}').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getStackedVariantV3 = poll(fetcher
    .path('/v3/assets/{id}/{variant1}/{variant2}/{variant3}')
    .method('get')
    .create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getAssetInfoV3 = fetcher.path('/v3/assets/{id}/info').method('get').create();
export const getImageInfoV3WithPolling = poll(fetcher.path('/v3/assets/{id}/info/image').method('get').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getImageClassificationInfoV3 = fetcher
    .path('/v3/assets/{id}/info/image/classifications')
    .method('get')
    .create();
export const getStorageInfoV3 = fetcher.path('/v3/assets/{id}/info/storage').method('get').create();
export const getImageInfoMultipageV3 = fetcher.path('/v3/assets/{id}/{pageNum}/info/image').method('get').create();
// assetStore already have the basicInfo hence this API is redundant for now
export const getBasicAssetInfoV3 = fetcher.path('/v2/assets/{id}/info/asset').method('get').create();
export const getExtractedLogoV3 = fetcher.path('/v3/assets/{id}/extractedLogos').method('get').create();
export const getExtractedLogoWithIdV3 = fetcher.path('/v3/assets/{id}/extractedLogos/{index}').method('get').create();
export const getVectorExtractedLogo = fetcher.path('/v3/assets/{id}/vectorExtractedLogos').method('get').create();
export const getExtractedLogoWithitemNumber = fetcher
    .path('/v3/assets/{id}/extractedLogos/itemAt_{itemNumber}')
    .method('get')
    .create();
export const getVectorExtractedLogoWithVersionV3 = fetcher
    .path('/v3/assets/{id}/versions/{version}/vectorExtractedLogos')
    .method('get')
    .create();
export const getVectorExtractedLogoWithVersionAndItemNumberV3 = fetcher
    .path('/v3/assets/{id}/versions/{version}/vectorExtractedLogos/itemAt_{itemNumber}')
    .method('get')
    .create();
export const getFontsV3 = fetcher.path('/v3/assets/{id}/info/font').method('get').create();
export const getColorsInfoV3 = fetcher.path('/v3/assets/{id}/info/image/colors').method('get').create();
export const createAssetByDocumentItemWithPollingV3 = poll(fetcher.path('/v3/assets').method('post').create({ defaultInit: DEFAULT_INIT_POLLING }));
export const getDocumentItemInfoV3 = poll(fetcher.path('/v3/assets/{id}/info/documentItem').method('get').create());
export const getImageTextV3 = poll(fetcher.path('/v3/assets/{id}/info/image/text').method('get').create());
//# sourceMappingURL=sherbertClientV3.js.map